import { type SideBySideExperiment } from '@atlassian/search-experiment';
export type ExperimentString = `${string}:${string}:${string}`;

export const getExperimentsFromSearchParam = (
	experimentsString?: string,
): SideBySideExperiment[] => {
	if (!experimentsString) {
		return [];
	}

	const experimentStrings = experimentsString.split(',') as Array<ExperimentString>;

	return experimentStrings.reduce(
		(experiments: SideBySideExperiment[], experimentString: ExperimentString) => {
			const [location, type, name, layer] = experimentString.split(':');

			if (!location || !type || !name) {
				return experiments;
			}

			experiments.push({
				location,
				type,
				name,
				layer,
			} as SideBySideExperiment);

			return experiments;
		},
		[] as SideBySideExperiment[],
	);
};
